module.exports = __webpack_public_path__ + "img/202501_02.929b5051.jpg";